<div class="col-md-12 float-left customersearch-forms login-forms p-0 customer-home-forms mb-4">
  <form [formGroup]="quoteSearchForm">
    <div class="request-quote-search row mx-0">
      <div class="form-group mt-3 col-lg-6 col-md-12 col-sm-12 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100"
          [value]="getSelectedCustomerSummary()"
          placeholder="Account # | Name | City"
          disabled
        />
        <span class="highlight"></span>
        <label class="text-muted">Account #, Name, City</label>
      </div>
    </div>
    <div class="request-quote-search row mx-0">
      <div class="form-group mt-3 col-lg-2 col-md-4 col-sm-6 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100"
          [placeholder]="'quoteRequestSearchForm.placeholder.suggestedQuote' | cxTranslate"
          formControlName="quoteRequestNumber"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteRequestSearchForm.label.quoteReqNo' | cxTranslate }}</label>
      </div>
      <div class="form-group mt-3 col-lg-2 col-md-4 col-sm-6 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100"
          [placeholder]="'quoteRequestSearchForm.label.customerPO' | cxTranslate"
          formControlName="customerPO"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteRequestSearchForm.label.customerPO' | cxTranslate }}</label>
      </div>
      @if (brandSalesShipToList$ | async; as items) {
        <div class="form-group mt-3 col-lg-2 col-md-4 col-sm-6 pl-0 float-left mb-3 p-res-0 multi-select-styles">
          <ng-select [items]="items.brand" [clearSearchOnAdd]="true"
            [closeOnSelect]="false" labelForId="state" [multiple]="true" placeholder="Brand"
            clearAllText="Clear" formControlName="brandName" [bindLabel]="'name'" [(ngModel)]="pBrandName">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="brand-option-row">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                {{ item['name'] }}
              </div>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items">
              @for (item of items | slice:0:1; track item) {
                <div class="ng-value">
                  {{ item['name'] }}
                </div>
              }
              @if (items.length > 1) {
                <div class="ng-value">
                  <span class="ng-value-label">{{ items.length - 1 }} more...</span>
                </div>
              }
            </ng-template>
          </ng-select>
          <span class="highlight"></span>
          <label class="text-muted">{{ 'orderReturnsSearchForm.label.brand' | cxTranslate }}</label>
        </div>
      }
      <div class="form-group mt-3 col-lg-2 col-md-4 col-sm-6 pl-0 float-left mb-3 p-res-0">
        <input
          type="date"
          class="form-control w-100"
          formControlName="fromDate"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteRequestSearchForm.label.from' | cxTranslate }}</label>
      </div>
      <div class="form-group mt-3 col-lg-2 col-md-4 col-sm-6 pl-0 float-left mb-3 p-res-0">
        <input
          type="date"
          class="form-control w-100"
          formControlName="toDate"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteRequestSearchForm.label.to' | cxTranslate }}</label>
      </div>
      <div class="form-group mt-3 col-lg-2 col-md-4 col-sm-6 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100"
          [placeholder]="'quoteRequestSearchForm.label.quote' | cxTranslate"
          formControlName="quoteNumber"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteRequestSearchForm.label.quote' | cxTranslate }}</label>
      </div>
    </div>
    <div class="col-lg-12 p-0 float-left">
      <div class="col-lg-2 pl-0 p-res-0 float-left request-quote-action-button">
        <button type="button" class="w-100 mt-1 mt-sm-0 btn btn-primary" (click)="submitForm()">
          {{ 'button.search' | cxTranslate }}
        </button>
      </div>
      <div class="col-lg-2 pl-0 p-res-0 float-left request-quote-action-button">
        <button type="button" class="w-100 mt-1 mt-sm-0 btn btn-outline-primary" (click)="resetForm()">
          {{ 'button.reset' | cxTranslate }}
        </button>
      </div>
    </div>
  </form>
</div>

<ng-container>
  @if (quoteSearchResult$ | async; as quoteSearchResult) {
    <div class="request-quote-results product-main-grid col-md-12 p-0 d-flex f-flow-col">
      @if (sorts$ | async; as sorts) {
        <div class="row">
          <div class="col-sm-6 col-md-6 col-lg-7 d-flex align-items-center">
            @if (paginate$ | async; as paginate) {
              <div class="p-2 mt-2 font-text-400 font-md-size text-muted request-quote-summary">
                {{ 'quoteRequestResult.showingDetail' | cxTranslate:{ current: quoteSearchResult.length, total: paginate?.totalResults || quoteSearchResult.length } }}
              </div>
            }
          </div>
          <div class="col-sm-6 col-md-6 col-lg-5 d-flex justify-content-end">
            <div class="mt-2 pt-1 sortBy">Sort By</div>
            <cx-sorting class="w-60" [sortOptions]="sorts" [sortLabels]="getSortLabels() | async"
              (sortListEvent)="changeSortCode($event)" [selectedOption]="sortType"
              placeholder="{{ 'orderHistory.sortByMostRecent' | cxTranslate }}">
            </cx-sorting>
          </div>
        </div>
      }
      <div class="col-lg-12 product-list-view p-0">
        @if (quoteSearchResult && quoteSearchResult.length) {
          <div class="row counter-wrapper">
            <div class="customersearch-list-table float-left col-lg-12 mt-3">
              <div class="customersearch-list-titles border-top float-left w-100 pl-2 pr-2 pt-3 pb-3 d-none d-sm-none d-lg-block">
                <div class="col-md-1 float-left font-text-400 pl-0 font-md-size text-muted">
                  {{ 'quoteRequestResult.header.brand' | cxTranslate }}
                </div>
                <div class="col-md-2 float-left font-text-400 pl-0 font-md-size text-muted quote-request-col">
                  {{ 'quoteRequestResult.header.quoteRequest' | cxTranslate }}
                </div>
                <div class="col-md-1 float-left font-text-400 pl-0 font-md-size text-muted created-on-col">
                  {{ 'quoteRequestResult.header.createdOn' | cxTranslate }}
                </div>
                <div class="col-md-2 float-left font-text-400 pl-0 font-md-size text-muted customer-col">
                  {{ 'quoteRequestResult.header.customer' | cxTranslate }}
                </div>
                <div class="col-md-2 float-left font-text-400 pl-0 font-md-size text-muted customer-name-col">
                  {{ 'quoteRequestResult.header.customerName' | cxTranslate }}
                </div>
                <div class="col-md-2 float-left font-text-400 pl-0 font-md-size text-muted">
                  {{ 'quoteRequestResult.header.jobName' | cxTranslate }}
                </div>
                <div class="col-md-1 float-left font-text-400 pl-0 font-md-size text-muted quote-col">
                  {{ 'quoteRequestResult.header.quote' | cxTranslate }}
                </div>
                <div class="col-md-1 float-left font-text-400 pl-0 font-md-size text-muted text-right total-col">
                  {{ 'quoteRequestResult.header.total' | cxTranslate }}
                </div>
              </div>
              @for (quote of quoteSearchResult; track quote) {
                <div class="bg-white customersearch-list-titles table-content border-top float-left w-100 py-2 px-3 font-weight-normal d-flex align-items-center" (click)="goToRequestDetails(quote.code)">
                  <div class="col-md-1 float-left title-wrap pl-0 font-md-size color-font text-muted">
                    <span class="res-titles">{{ 'quoteRequestResult.header.brand' | cxTranslate }}</span>
                    <span>{{ quote.brandName }}</span>
                  </div>
                  <div class="col-md-2 float-left title-wrap pl-0 font-md-size color-font text-muted quote-request-col">
                    <span class="res-titles">{{ 'quoteRequestResult.header.quoteRequest' | cxTranslate }}</span>
                    <span>{{ quote?.code }}</span>
                  </div>
                  <div class="col-md-1 float-left title-wrap pl-0 font-md-size color-font text-muted created-on-col">
                    <span class="res-titles">{{ 'quoteRequestResult.header.createdOn' | cxTranslate }}</span>
                    {{ quote.creationDate }}
                  </div>
                  <div class="col-md-2 float-left title-wrap pl-0 font-md-size color-font text-muted customer-col">
                    <span class="res-titles">{{ 'quoteRequestResult.header.customer' | cxTranslate }}</span>
                    {{ quote.accountNumber }}
                  </div>
                  <div class="col-md-2 float-left title-wrap pl-0 font-md-size color-font text-muted customer-name-col">
                    <span class="res-titles">{{ 'quoteRequestResult.header.customerName' | cxTranslate }}</span>
                    {{ quote.accountName }}
                  </div>
                  <div class="col-md-2 float-left title-wrap pl-0 font-md-size color-font text-muted">
                    <span class="res-titles">{{ 'quoteRequestResult.header.jobName' | cxTranslate }}</span>
                    {{ quote?.purchaseOrderNumber }}
                  </div>
                  <div class="col-md-1 float-left title-wrap pl-0 font-md-size color-font text-muted quote-col">
                    <span class="res-titles">{{ 'quoteRequestResult.header.quote' | cxTranslate }}</span>
                    {{ quote?.quoteReferenceCode }}
                  </div>
                  <div class="col-md-1 float-left title-wrap pl-0 font-md-size color-font text-muted text-right total-col">
                    <span class="res-titles">{{ 'quoteRequestResult.header.total' | cxTranslate }}</span>
                    {{ quote?.totalPrice?.value === 0 ? 'Quoted' : quote?.totalPrice?.formattedValue }}
                  </div>
                </div>
              }
            </div>
            @if (paginate$ | async; as paginate) {
              <div class="col-lg-12 d-flex request-quote-pagination">
                <div class="col-lg-6 p-4 mt-2 font-text-400 font-md-size text-muted">
                  {{ 'quoteRequestResult.showingDetail' | cxTranslate:{ current: quoteSearchResult.length, total: paginate?.totalResults || quoteSearchResult.length } }}
                </div>
                <div class="col-lg-6 w-100 mt-3 text-right">
                  @if (paginate.currentPage < paginate.totalPages - 1 && !(isLoading$ | async)) {
                    <div class="btn btn-loadmore mt-0 mr-3" (click)="loadMore(paginate.currentPage)">
                      {{ 'quoteRequestResult.showMore' | cxTranslate }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (quoteSearchResult && quoteSearchResult.length < 1 && !(isLoading$ | async)) {
          <div class="alert-info p-3 rounded mt-3">
            {{ 'quoteRequestResult.nodataMsg' | cxTranslate }}
          </div>
        }
      </div>
    </div>
  }
</ng-container>